angular.module('unica_invitation_transfer.invitation_transfer_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// TRANSFER INVITATION LIST
		.state('app.hospitality.invitation_transfer_list', {
			url: '/invitation-transfer-list/:event_id',
			views: {
				'hospitalityContent': {
					templateUrl: './modules/invitation-transfer/templates/list.html',
					controller: 'InvitationTransferListController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Configura Transfer',
				parent: function($scope) {
					return 'app.hospitality.invitation_transfer_event_list({event_id:' + $scope.event_id + '})';
				}
			}
		})

		// TRANSFER INVITATION CREATE
		.state('app.hospitality.invitation_transfer_create', {
			url: '/invitation-transfer-create/:event_id',
			views: {
				'hospitalityContent': {
					templateUrl: './modules/invitation-transfer/templates/create.html',
					controller: 'InvitationTransferCreateController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Aggiungi Transfer Evento',
				parent: function($scope) {
					return 'app.hospitality.invitation_transfer_list({event_id:' + $scope.event_id + '})';
				}
			}
		})

		// TRANSFER INVITATION EDIT
		.state('app.hospitality.invitation_transfer_edit', {
			url: '/invitation-transfer-edit/:event_id/:id',
			views: {
				'hospitalityContent': {
					templateUrl: './modules/invitation-transfer/templates/edit.html',
					controller: 'InvitationTransferEditController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Modifica Configurazione Transfer',
				parent: function($scope) {
					return 'app.hospitality.invitation_transfer_list({event_id:' + $scope.event_id + '})';
				}
			}
		});




});

